import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

new Vue({
  data: {
    connection: undefined,
    streamid: null,
    password: null
  },
  render: h => h(App),
}).$mount('#app')
